import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import './i18n';

import App from "./App";
import { Amplify } from "aws-amplify";
import config from "./aws-exports";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from "./reportWebVitals";
import { regions } from './config';
import "@aws-amplify/ui-react/styles.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

Amplify.configure(config);

export const DataContext = React.createContext();

const router = createBrowserRouter([
  ...Object.keys(regions).map(region => (
    {
      path: `/${region}`,
      element: <App region={regions[region]} />
    }
  ))
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
